/**
 * Baubeau — inscription newsletter (bandeau prénom + email).
 *
 * Le formulaire se soumet normalement (comportement natif Shopify,
 * rechargement de page) — voir prompt-handoff-header-rsvp.md pour le
 * pourquoi (protection anti-bot Cloudflare bloquant les tentatives
 * d'inscription sans rechargement en environnement de dev/preview).
 *
 * Ce script se contente d'ajouter une classe au moment du clic pour
 * déclencher la transition visuelle du bouton (flèche → monogramme,
 * si l'option est activée) pendant le court instant avant le
 * rechargement natif.
 */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.baubeau-newsletter__native-form').forEach((form) => {
    form.addEventListener('submit', () => {
      form.classList.add('is-loading');
    });
  });
});
